import type { TableProps } from '@risk-smart/themed-cloudscape-components/table';

/**
 * Extract the plain-text label for a Cloudscape column.
 *
 * The internal `useCreateColumnDefinitions` factory attaches a non-standard
 * `headerText` property to every column it builds (see `RiskSmartColumnDefinition`
 * in that file). That is the canonical path; any column constructed through the
 * factory will have `headerText` set.
 *
 * The `header`-string fallback remains for the rare third-party / hand-rolled
 * `ColumnDefinition` that omits `headerText`. JSX-wrapped headers without a
 * matching `headerText` are unsupported — callers needing a string label must
 * supply `headerText` alongside any JSX header (the factory enforces this).
 */
export const getColumnHeaderText = <T>(
  column: TableProps.ColumnDefinition<T> & { headerText?: string }
): string => {
  if (typeof column.headerText === 'string') {
    return column.headerText;
  }
  if (typeof column.header === 'string') {
    return column.header;
  }

  return '';
};
